// extracted by mini-css-extract-plugin
export var cardslide = "BreedCardCarousel-module--cardslide--5978f";
export var pagination = "BreedCardCarousel-module--pagination--64584";
export var swiper = "BreedCardCarousel-module--swiper--d4f27";
export var swiperwrapper = "BreedCardCarousel-module--swiperwrapper--36e34";